const initialState = {
  loading: false,
  success: null,
  error: null
}

function registerReducer(state = initialState, action) {
  switch (action.type) {
    case 'AUTH_REGISTER_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'AUTH_REGISTER_SUCCESS':
      return {
        ...state,
        success: action.success,
        loading: false
      }

    case 'AUTH_REGISTER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: 
      return state
  }
}

export default registerReducer